import { Button, Flex, Input, Typography } from "antd";
import { useEffect, useState } from "react";
import { isEmptyString } from "../../../util/helper/helperFunctions";
const { Text } = Typography;
const ColumnSearch = ({ field, label, updateFilter, searchFilters }) => {
  const [searchText, setSearchText] = useState(searchFilters[field] || "");
  const [invalidMessage, setInvalidMessage] = useState(null);

  const handleSearch = () => {
    updateFilter(field, searchText);
  };

  const handleReset = () => {
    updateFilter(field, "");
    setSearchText("");
    setInvalidMessage(null);
  };

  useEffect(() => {
    setSearchText(searchFilters[field] || "");
  }, [searchFilters, field]);

  const handleChange = (value) => {
    setSearchText(value);
    if (isEmptyString(value)) {
      setInvalidMessage("Value cannot be empty");
    } else {
      setInvalidMessage(null);
    }
  };

  return (
    <Flex gap="small" vertical>
      <Flex gap="small">
        <Input
          placeholder={`Search ${label}`}
          value={searchText}
          onChange={(e) => handleChange(e.target.value)}
          onPressEnter={!isEmptyString(searchText) && handleSearch}
        />
        <Button onClick={handleSearch} disabled={invalidMessage || !searchText}>
          Search
        </Button>
        <Button danger disabled={!searchText} onClick={handleReset}>
          Reset
        </Button>
      </Flex>
      {invalidMessage && (
        <Text align type="danger">
          {invalidMessage}
        </Text>
      )}
    </Flex>
  );
};

export default ColumnSearch;
